export default __webpack_public_path__ + "static/media/ID.c7ba26bb.svg";